import { useState, useCallback } from 'react';
import { RegiaoComprasDrillDownData, RegiaoComprasData } from '../types/regiaoComprasDrillDown';

export const useRegiaoComprasDrillDown = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRegiao, setSelectedRegiao] = useState<RegiaoComprasData | null>(null);
  const [drillDownData, setDrillDownData] = useState<RegiaoComprasDrillDownData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const openModal = useCallback(async (regiaoData: RegiaoComprasData, spedFiscalId: number) => {
    if (!spedFiscalId) {
      setError('ID do SPED Fiscal não fornecido.');
      return;
    }
    
    setSelectedRegiao(regiaoData);
    setIsModalOpen(true);
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/regiao-compras-drill-down/${spedFiscalId}/${regiaoData.nome}`);
      if (!response.ok) {
        throw new Error(`Erro na API: ${response.statusText}`);
      }
      const data: RegiaoComprasDrillDownData = await response.json();
      setDrillDownData(data);
    } catch (err: any) {
      setError(err.message || 'Falha ao buscar dados de drill down.');
    } finally {
      setLoading(false);
    }
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedRegiao(null);
    setDrillDownData(null);
  }, []);

  const retry = useCallback(() => {
    if (selectedRegiao && selectedRegiao.spedFiscalId) {
      openModal(selectedRegiao, selectedRegiao.spedFiscalId);
    }
  }, [selectedRegiao, openModal]);

  return {
    isModalOpen,
    selectedRegiao,
    drillDownData,
    loading,
    error,
    openModal,
    closeModal,
    retry,
  };
};
